module.exports = __webpack_public_path__ + "static/media/IconGavelRed.2302e925.svg";